import {
  ENTER_KEY,
  ESC_KEY
} from './const';

export class Sidebar {
  constructor(id, options) {
    this._elem = document.querySelector(id);
    if (this._elem === null) {
      return;
    }
    this._cls = '.js-sidebar';
    // this._overlay = document.querySelector('.overlay');
    this._firstId = `#${this._elem.querySelector('.sidebar__inner').id}`;
    this._startId = this._firstId;
    this._isVisible = false;
    this._history = [];

    this.toggler = false;
    Object.assign(this, options);

    if (this.toggler) {
      this._toggler = document.querySelector(this.toggler);
    }


    this._buttonClickHandler = this._buttonClickHandler.bind(this);
    // this._overlayClickHandler = this._overlayClickHandler.bind(this);
    this._documentKeydownHandler = this._documentKeydownHandler.bind(this);
    this._documentTouchmoveHandler = this._documentTouchmoveHandler.bind(this);

    this._setHandlers();
  }

  getElem() {
    return this._elem;
  }

  handleEvent(evt) {
    switch (evt.type) {
      case 'click':
        if (this._isTab(evt)) {
          let link = evt.target.closest('a');
          let id = link.hash;
          this.show(id);
        }
        if (this._isBtnClose(evt)) {
          this.hide();
        }
        if (this._isBtnBack(evt)) {
          const id = this._getBackId();
          this.show(id);
        }
        break;
      case 'keydown':
        if (this._isBtnClose(evt)) {
          if (evt.key === ENTER_KEY) {
            this.hide();
          }
        }
        break;
    }
  }

  show(id) {
    this._history.push(id || this._firstId);
    if (id) {
      this._switch(id);
    }
    if (this._isVisible === false) {
      this._open();
    }
  }

  hide() {
    if (!this._elem.classList.contains('active')) {
      return;
    }
    this._elem.classList.remove('active');
    this._elem.removeEventListener('click', this);
    this._elem.removeEventListener('keydown', this);

    // this._overlay.classList.remove('overlay--show');
    // this._overlay.removeEventListener('click', this._overlayClickHandler);

    document.body.classList.remove('overflow');

    document.removeEventListener('keydown', this._documentKeydownHandler);
    document.removeEventListener('touchmove', this._documentTouchmoveHandler, {
      passive: true
    });

    this._isVisible = false;
    this._history = [];

    if (this._toggler) {
      this._toggler.classList.remove('active');
    }
  }

  _open() {
    this._elem.classList.add('active');
    this._elem.focus();
    this._elem.addEventListener('click', this);
    this._elem.addEventListener('keydown', this);

    // this._overlay.classList.add('overlay--show');
    // this._overlay.addEventListener('click', this._overlayClickHandler);

    document.body.classList.add('overflow');

    document.addEventListener('keydown', this._documentKeydownHandler);
    document.addEventListener('touchmove', this._documentTouchmoveHandler);

    this._isVisible = true;

    if (this._toggler) {
      this._toggler.classList.add('active');
    }
  }

  _getBackId() {
    let id = '';
    if (this._history.length > 1) {
      id = this._history[this._history.length - 2];
    } else {
      id = `#${this._elem.querySelector('.sidebar__inner').id}`;
    }
    this._history = this._history.slice(0, -2);

    return id;
  }

  _switch(id) {
    const activeTab = this._elem.querySelector(id);
    const oldTab = this._elem.querySelector(this._firstId);
    this._firstId = id;

    if (activeTab !== oldTab) {
      activeTab.classList.add('sidebar__inner--show');
      oldTab.classList.remove('sidebar__inner--show');
    }
  }

  _setHandlers() {
    const buttons = document.querySelectorAll(this._cls);
    buttons.forEach((button) => {
      button.addEventListener('click', this._buttonClickHandler);
    });
  }

  _buttonClickHandler(evt) {
    const elem = evt.target.closest('a') || evt.target.closest('button');
    if (this._isVisible) {
      this.hide();
    } else if (elem.getAttribute('data-sidebar') === this._elem.id) {
      const data = elem.getAttribute('data-tab');
      const id = data ? data : null;
      evt.preventDefault();
      this.show(id);
    }
  }

  _overlayClickHandler() {
    this.hide();
  }

  _documentKeydownHandler(evt) {
    if (evt.key === ESC_KEY) {
      this.hide();
    }
  }

  _documentTouchmoveHandler(evt) {
    evt.preventDefault();
  }

  _isTab(evt) {
    const elem = evt.target.closest('a');
    if (elem) {
      return elem.href.includes('#sidebar-');
    }
    return false;
  }

  _isBtnClose(evt) {
    return evt.target.closest('.sidebar__close');
  }

  _isBtnBack(evt) {
    return evt.target.closest('.sidebar__back');
  }
}

// export class Menu extends Sidebar {
//   updateCart(number) {
//     const cart = this._elem.querySelector('.top-sidebar__item--cart');
//     const count = cart.querySelector(`.top-sidebar__count`);
//     if (count === null) {
//       const countContainer = cart.querySelector(`.top-sidebar__icon`);
//       const countTemplate = `<span class="top-sidebar__count circle-count circle-count--small">${number}</span>`;
//       countContainer.insertAdjacentHTML(`beforeend`, countTemplate);

//       const subtext = cart.querySelector(`.top-sidebar__subtext`);
//       subtext.classList.add('top-sidebar__subtext--active');
//       subtext.textContent = `Перейти к оформлению заказа`;
//     } else {
//       count.textContent = number;
//     }
//   }
// }
